import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utilities/helpers";
import instance from "../api";
import TokenService from "./token.service";

const siteLogoutUrl = process.env.REACT_APP_LOGOUT_URL;

const logout = () => {
  TokenService.removeUser();
  if (siteLogoutUrl) window.location.assign(siteLogoutUrl);
  localStorage.clear();
};

const accessTokenFromServer = async (refreshToken: any) => {
  try {
    const params = {
      ReferenceToken: refreshToken,
    };
    const response = await instance.get(ApiConstant.getToken, {
      params,
    });
    return response.data;
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const refreshTokenFromServer = async (refreshToken: string, accessToken: string): Promise<boolean> => {
  try {
    const response = await instance.get(ApiConstant.getRefreshToken, {
      params: { RefreshToken: refreshToken },
      headers: {
        "Authorization": `Bearer ${accessToken}`, 
        "Content-Type": "application/json",
      },
    });

    if (response?.data?.data?.token) {
      const data = response.data.data;
      TokenService.setRefreshTokenTimer(data.token.expires_in);
      TokenService.addOrUpdateLocalRefreshToken(data.token.refresh_token);
      TokenService.addOrUpdateLocalAccessToken(data.token.access_token);
      return true;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
  return false;
};

const isAuth = async (authStatus: boolean) => {
  if (authStatus) {
    if (siteLogoutUrl) window.location.assign(siteLogoutUrl);
    localStorage.clear();
  }
};

const AuthService = {
  logout,
  isAuth,
  accessTokenFromServer,
  refreshTokenFromServer,
};

export default AuthService;
